import React from "react";

const Footer = () => {

  return(
    <footer className="Footer-style text-center pb-2">
      &copy; 2018 CO Legislative Tracker
    </footer>
  )
}

export default Footer;